module.exports = __webpack_public_path__ + "img/1f02b40.jpg";